import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function IncludedSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const included = [{
    title: 'El método completo Timer + Zonas + Misiones',
    description: 'Todo el sistema explicado paso a paso para que empieces hoy mismo'
  }, {
    title: 'Misiones listas por zona',
    description: 'Cocina (lo que más se nota), Baño (reset nocturno), Sala/Entrada (zona vergüenza), Dormitorio (paz), Laundry (cortar el ciclo)'
  }, {
    title: 'Plan "Días caóticos"',
    description: 'Versión de 5 minutos, sin culpa, para cuando la vida se pone imposible'
  }, {
    title: 'Semana de rescate',
    description: '7 días estructurados para cuando todo se salió de control y necesitas volver a empezar'
  }, {
    title: 'Tracker para 30 días',
    description: 'Para que no dependa de motivación. Seguimiento simple que te mantiene en el camino'
  }];
  return <section ref={ref} className="w-full bg-[#F5F1E8] py-20 md:py-32 px-4" data-id="element-96">
      <div className="max-w-5xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#3A3A3A] mb-6 leading-tight" data-id="element-99">
            Lo que incluye
          </h2>
          <p className="text-xl text-[#5A5A5A]" data-id="element-100">
            PDF completo + imprimibles listos para usar
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-101">
          {included.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.1
        }} className="bg-white rounded-xl p-6 md:p-8 shadow-sm" data-id="element-102">
              <div className="flex items-start gap-4" data-id="element-103">
                <div className="flex-shrink-0 mt-1" data-id="element-104">
                  <CheckCircleIcon className="w-6 h-6 text-[#7B9FAB]" aria-hidden="true" data-id="element-105" />
                </div>
                <div className="flex-1" data-id="element-106">
                  <h3 className="text-xl font-semibold text-[#3A3A3A] mb-2" data-id="element-107">
                    {item.title}
                  </h3>
                  <p className="text-[#5A5A5A] leading-relaxed" data-id="element-108">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="mt-16 bg-white rounded-2xl p-8 md:p-12" data-id="element-109">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-110">
            <div data-id="element-111">
              <h3 className="text-2xl font-serif text-[#3A3A3A] mb-4" data-id="element-112">
                Esto es para ti si:
              </h3>
              <ul className="space-y-3 text-[#5A5A5A]" data-id="element-113">
                <li className="flex items-start gap-2" data-id="element-114">
                  <span className="text-[#7B9FAB] mt-1" data-id="element-115">•</span>
                  <span data-id="element-116">Estás cansada de empezar y abandonar</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-117">
                  <span className="text-[#7B9FAB] mt-1" data-id="element-118">•</span>
                  <span data-id="element-119">
                    Quieres que tu casa se sienta manejable sin ser perfecta
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-120">
                  <span className="text-[#7B9FAB] mt-1" data-id="element-121">•</span>
                  <span data-id="element-122">
                    Tienes vida real: trabajo, niños, estrés, poco tiempo
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-123">
                  <span className="text-[#7B9FAB] mt-1" data-id="element-124">•</span>
                  <span data-id="element-125">Te pesa la culpa y quieres un sistema simple</span>
                </li>
              </ul>
            </div>
            <div data-id="element-126">
              <h3 className="text-2xl font-serif text-[#3A3A3A] mb-4" data-id="element-127">
                No es para ti si:
              </h3>
              <ul className="space-y-3 text-[#5A5A5A]" data-id="element-128">
                <li className="flex items-start gap-2" data-id="element-129">
                  <span className="text-[#5A5A5A] mt-1" data-id="element-130">•</span>
                  <span data-id="element-131">Quieres un deep clean profesional detallado</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-132">
                  <span className="text-[#5A5A5A] mt-1" data-id="element-133">•</span>
                  <span data-id="element-134">Buscas minimalismo extremo</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-135">
                  <span className="text-[#5A5A5A] mt-1" data-id="element-136">•</span>
                  <span data-id="element-137">
                    Quieres comprar organizadores y rehacer toda tu casa
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}